import { render, staticRenderFns } from "./Cover.vue?vue&type=template&id=0fc1ce8a&scoped=true&"
import script from "./Cover.vue?vue&type=script&lang=ts&"
export * from "./Cover.vue?vue&type=script&lang=ts&"
import style0 from "./Cover.vue?vue&type=style&index=0&id=0fc1ce8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc1ce8a",
  null
  
)

export default component.exports